/// <amd-module name="Environments/Providers/VirtualMachineGroups/Utilities" />

import { IPanelTitleProps } from "VSSUI/Panel";
import { TitleSize } from "VSSUI/Header";

export class PageKey {
    public static AddVirtualMachinesResourceView = "add-virtualmachines-service-group";
    public static VirtualMachineGroupTargetsView = "virtualmachinegroup-targets";
    public static AddTargetView = "add-targets";
}

export function getTitle(text: string): IPanelTitleProps {
    const panelTitle = {
        className: "fontWeightHeavy",
        text: text,
        size: TitleSize.Large
    } as IPanelTitleProps;

    return panelTitle;
}

export const AzureRMEndpointType = "azurerm";
export const ResourceId = "resourceId";

export const targetsCount: number = 25;
